module.exports = __webpack_public_path__ + "static/media/zh.753a4f77.svg";